const typeFlat = {
  FLAT: 3, // квартира
  STORAGE: 5, // кладовка
  OFFICE: 7, // офис
};

const typeFlatEnum = [typeFlat.FLAT, typeFlat.OFFICE, typeFlat.STORAGE];

export const getOptionsSelect = ({
  data = [],
  isFlat = false,
  isClient = false,
}) => {
  if (!Array.isArray(data)) return [];

  return data?.map((item) => ({
    ...item,
    key: item.id,
    value: item.id || item.name,
    content: isFlat
      ? `${
          typeFlatEnum.find((typeId) => typeId === item.typeId)
            ? item.typeShortName
            : ''
        } ${item.name}`
      : isClient
      ? item.fio || item.name || 'Нет данных о клиенте'
      : item.name || item.id,
    search: isClient ? item.fio || item.name : item.name || item.id,
  }));
};
